import { render, staticRenderFns } from "./postList.vue?vue&type=template&id=0f9b202c"
import script from "./postList.vue?vue&type=script&lang=js"
export * from "./postList.vue?vue&type=script&lang=js"
import style0 from "./postList.vue?vue&type=style&index=0&id=0f9b202c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports